import { useQuery } from '@apollo/client';
import { UserRole } from 'gql/types';
import { useCurrentUser } from 'modules/user/hooks/useCurrentUser';
import { useMemo } from 'react';

import { GET_NIGHTLY_COUNT_OFFICES_QUERY } from '../graphql/queries';

interface IAllowedOffice {
  id: string;
  name: string;
  regionName: string;
}

export const useNightlyCountAccess = () => {
  const currentUser = useCurrentUser();
  const role = currentUser.data?.role?.value;
  const isAdmin = role === UserRole.Admin;
  const isOps = role === UserRole.Operations;
  const isAdminOrOps = isAdmin || isOps;

  const { data, loading } = useQuery<{
    getNightlyCountOfficesForCurrentUser: IAllowedOffice[];
  }>(GET_NIGHTLY_COUNT_OFFICES_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const allowedOffices: IAllowedOffice[] = useMemo(
    () => data?.getNightlyCountOfficesForCurrentUser || [],
    [data]
  );

  const canDelete = isAdmin;
  const canEnterForAny = isAdminOrOps || allowedOffices.length > 0;
  const canEditOffice = (officeId: string) =>
    isAdminOrOps || allowedOffices.some((o) => o.id === officeId);

  return {
    role,
    isAdmin,
    isOps,
    isAdminOrOps,
    allowedOffices,
    canDelete,
    canEnterForAny,
    canEditOffice,
    isLoadingAccess: loading,
  };
};
